import { jsx as r } from "react/jsx-runtime";
import { Accordion as e } from "@chakra-ui/react";
import { AccordionVariantContext as n } from "./accordion-context.js";
function l({ children: c, variant: o = "border", ...i }) {
  return /* @__PURE__ */ r(n.Provider, { value: o, children: /* @__PURE__ */ r(e, { variant: o, allowToggle: !0, ...i, children: c }) });
}
export {
  l as Accordion
};
